import { createI18n } from 'vue-i18n';
import { it } from '@/lang/it';

export const i18n = createI18n({
  locale: 'it',
  messages: { it },
  lazy: true
});
